import { Barcode } from "@/components/stock/LabelSheet";
import { brl } from "@/lib/api";

const day = (d) => (d ? d.split("-").reverse().join("/") : "");
export const fmtKg = (v) => Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3 });

export function ScaleLabel({ p, cfg, store = "" }) {
  const { width: w, height: h } = cfg;
  const s = Math.min(w / 60, h / 40);
  const pt = (n) => `${(n * s).toFixed(2)}pt`;
  return (
    <div className="flex flex-col justify-between overflow-hidden bg-white text-black" style={{ width: `${w}mm`, height: `${h}mm`, padding: `${1.5 * s}mm ${2 * s}mm` }}>
      {store && <p className="truncate font-semibold uppercase leading-tight" style={{ fontSize: pt(5.5) }}>{store}</p>}
      <p className="line-clamp-2 font-bold leading-tight" style={{ fontSize: pt(8) }}>{p.name}</p>
      <div className="flex items-end justify-between gap-1 leading-tight" style={{ fontSize: pt(6.5) }}>
        <span>Peso <b>{fmtKg(p.weight)} kg</b><br />R$/kg <b>{brl(p.price)}</b></span>
        <span className="text-right">Total<br /><b style={{ fontSize: pt(13) }}>{brl(p.total)}</b></span>
      </div>
      <p className="truncate leading-tight" style={{ fontSize: pt(5.5) }}>Embalado {day(p.packed)}{p.expiry ? ` · Val. ${day(p.expiry)}` : ""}</p>
      {p.code ? <Barcode code={p.code} heightMm={h * 0.3} /> : <span />}
    </div>
  );
}
